const translations = {
  title: "Repair Jobs",
  subtitle: "Track repair, soldering, and polishing jobs for customers.",
  newRepair: "New Repair",
  repairNo: "Repair No.",
  repairDate: "Date",
  repairDetail: "Repair Detail",
  repairNotFound: "Repair job not found.",
  allRepairs: "All Repairs",
  // Fields
  customer: "Customer",
  itemDescription: "Item Description",
  repairType: "Repair Type",
  type_repair: "Repair / Soldering",
  type_polishing: "Polishing / Cleaning",
  type_rhodium: "Rhodium Plating",
  type_sizing: "Ring Sizing",
  type_stone_setting: "Stone Setting",
  type_engraving: "Engraving",
  type_other: "Other",
  estimatedCost: "Estimated Cost (₹)",
  finalCost: "Final Cost (₹)",
  advanceReceived: "Advance Received (₹)",
  balance: "Balance (₹)",
  expectedDelivery: "Expected Delivery",
  actualDelivery: "Actual Delivery",
  notes: "Notes",
  internalNotes: "Internal Notes",
  // Item details
  grossWeightIn: "Weight In (g)",
  grossWeightOut: "Weight Out (g)",
  stoneDetails: "Stone Details",
  // Status
  status_received: "Received",
  status_in_progress: "In Progress",
  status_ready: "Ready for Delivery",
  status_delivered: "Delivered",
  status_cancelled: "Cancelled",
  // Actions
  createRepair: "Create Repair",
  markReady: "Mark Ready",
  markDelivered: "Mark Delivered",
  printReceipt: "Print Receipt",
  printJobCard: "Print Job Card",
  addPayment: "Add Payment",
  // Empty states
  noRepairs: "No repair jobs yet.",
  createFirst: "Create the first repair job.",
  // Columns
  col_repairNo: "Repair No.",
  col_customer: "Customer",
  col_item: "Item",
  col_type: "Type",
  col_cost: "Cost",
  col_advance: "Advance",
  col_balance: "Balance",
  col_delivery: "Delivery",
  col_status: "Status",
  col_action: "Action",
};

export default translations;
